import { ReactElement } from "react";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useGetEntityDocumentTypesQuery } from "v2/store/entityDocumentsApi";
import { MissingDetailsCallout } from "./MissingDetailsCallout";
import { useIsGroupV2Platform } from "hooks/useIsGroupV2Platform";

type CompanyMissingCalloutProps = {
  onView: () => void;
};

const EMPTY_ITEMS: [] = [];

export const CompanyMissingCallout = ({
  onView,
}: CompanyMissingCalloutProps): ReactElement | null => {
  const { uuid: groupId } = useCurrentGroupContext();
  const isV2Platform = useIsGroupV2Platform();

  const { data = EMPTY_ITEMS } = useGetEntityDocumentTypesQuery(
    { groupId },
    { skip: !groupId }
  );

  const totalMissing = data.filter((item) => !item.isSatisfied).length;

  if (totalMissing === 0 || !isV2Platform) return null;

  return (
    <MissingDetailsCallout
      scope="company"
      totalMissing={totalMissing}
      onView={onView}
    />
  );
};
